import { render, staticRenderFns } from "./screengroup-dialog.vue?vue&type=template&id=2f433889&scoped=true"
import script from "./screengroup-dialog.vue?vue&type=script&lang=js"
export * from "./screengroup-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f433889",
  null
  
)

export default component.exports